export const FuelPlanFeedbackOutcome = {
  Success: "Success",
  Unavailable: "Unavailable",
  RequestFailed: "RequestFailed",
} as const;
